module.exports = __webpack_public_path__ + "img/LanghamBostonBanner.6f243d4d.jpg";